import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { TranslateService } from '../../services/translate/translate.service';
import { InfoTokenService } from './../../services/infoUser/info-user.service';

import { Notifications } from '../../interfaces/toolbar/notifiactions.interface';
import { ContainPopover } from '../../interfaces/contain-popover.interface';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ModulesMangosI } from '../../interfaces/modules-mango.interface';
import { MatDialog } from '@angular/material/dialog';
import { ModalUsersComponent } from '../../components/modal-users/modal-users.component';
import { ModalPasskeysComponent } from '../../components/modal-passkeys/modal-passkeys.component';
import { MangoLayoutService } from '../../mango-layout.service';
import { IUser } from '../../interfaces/toolbar/toolbar.interface';

@Component({
  selector: 'mg-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit, OnChanges {
  @Input() notification!: Notifications;
  @Input() viewNotifications: boolean = true;
  @Input() showMenu = false;
  @Input() url = '';
  @Input() modules: ModulesMangosI[] = [];
  @Input() user!: IUser;
  @Input() showModules: boolean = true;
  @Output() sidebar = new EventEmitter<boolean>();
  defaultVisible: boolean = false;
  defaultVisibleLanguage = false;
  defaultVisibleSettings = false;
  defaultVisibleNotifications = false;
  language: string = '';
  nameModule = '';
  newNotification = true;
  amountNotifications: Notifications[] = [];
  notifications: Notifications[] = [];
  statusPopover: boolean = false;
  statusPopoverSettings = false;
  statusPopoverLanguage = false;
  statusPopoverNotifications = false;
  installEvent: any = null;

  greeting = '';

  constructor(
    private auth: AuthenticationService,
    private translate: TranslateService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private infoTokensService: InfoTokenService,
    private mangoLayoutService: MangoLayoutService
  ) {
    this.language = this.translateService.get();
  }

  ngOnInit(): void {
    // this.getUser();
    this.translate.init('core').subscribe((core) => {
      this.nameModule = core.toolbar.name || '';
      this.greeting = core.toolbar.greeting + ', ' || '';
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.notification) {
      this.notifications.push(this.notification);
    }
  }
  /**
   * Change language and emit
   */
  changeLanguage(item: ContainPopover) {
    const language = item.value || 'en';
    this.language = language;
    this.translate.update(language);
  }

  /**
   * get current user
   */

  /**
   * Open and close Modules
   */
  togglePopoverModules() {
    this.defaultVisible = !this.defaultVisible;
    if (this.defaultVisible === true) {
      this.statusPopover = true;
    }
  }

  /**
   * Module selected
   */
  moduleSelected(module: ModulesMangosI) {
    if (!location.hostname.includes(module.mainUrl)) {
      window.open(`https://${module.mainUrl?.trim()}`);
    }
  }

  /**
   * Close popover modules
   */
  ClosePopoverModules(item: any) {
    if (this.statusPopover === true) {
      this.statusPopover = false;
    } else {
      this.defaultVisible = item;
    }
  }

  /**
   * Button open and close sidebar
   */

  togglePopoverLanguage() {
    this.defaultVisibleLanguage = !this.defaultVisibleLanguage;
    if (this.defaultVisibleLanguage === true) {
      this.statusPopoverLanguage = true;
    }
  }

  closeTraslate(item: any) {
    if (this.statusPopoverLanguage === true) {
      this.statusPopoverLanguage = false;
    } else {
      this.defaultVisibleLanguage = item;
    }
  }

  togglePopoverSettings() {
    this.defaultVisibleSettings = !this.defaultVisibleSettings;
    if (this.defaultVisibleSettings === true) {
      this.statusPopoverSettings = true;
    }
  }

  settingsSelected(item: ContainPopover) {
    this.closePopoverSettings(item);
    switch (item.id) {
      case 1:
        const dialogRef = this.dialog.open(ModalUsersComponent, {
          height: '550px',
          width: '550px',
          maxWidth: '100vw',
          data: { data: this.user, url: this.url, rootViewTitle: true },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.user = {
              ...result,
            };
            this.infoTokensService.setName(this.user.fullName);
          }
        });
        break;

      case 2:
        const dialogRefPasskeys = this.dialog.open(ModalPasskeysComponent, {
          maxHeight: '80vh',
          height: 'auto',
          width: '500px',
          data: { data: this.user, url: this.url },
        });
        break;

      case 3:
        this.mangoLayoutService.emitActionCore('logout', true);
        this.auth.logout();
        break;
      case 4:
        this.installApp();
        break;
    }
  }

  closePopoverSettings(item: any) {
    if (this.statusPopoverSettings === true) {
      this.statusPopoverSettings = false;
    } else {
      this.defaultVisibleSettings = item;
    }
  }

  togglePopoverNotifications() {
    this.defaultVisibleNotifications = !this.defaultVisibleNotifications;
    if (this.defaultVisibleNotifications === true) {
      this.statusPopoverNotifications = true;
    } else {
      this.newNotification = false;
    }
  }

  closePopoverNotifications(item: any) {
    if (this.statusPopoverNotifications === true) {
      this.statusPopoverNotifications = false;
    } else {
      this.defaultVisibleNotifications = item;
    }
    this.newNotification = false;
  }

  installApp() {
    if (this.installEvent) {
      this.installEvent.prompt();
      this.installEvent.userChoice.then((rta: any) => {
        if (rta.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
      });
    }
  }

  @HostListener('window: beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    this.installEvent = event;
  }

  showMenuStatus(status: boolean) {
    this.sidebar.emit(status);
  }
}
